import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  drawerContent: {
    width: '50%',
    borderTop: '2px solid #23296F',
    borderRadius: 16,
  },
  closeBtn: {
    position: 'absolute',
    width: 50,
    height: 50,
    right: '0.001rem',
    top: '0.001rem',
    color: '#fff',
  },
  contentChild: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 30,
    paddingBottom: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 200px)',
  },
  title: {
    lineHeight: '30px',
    color: '#fff',
    textTransform: 'none',
    marginBottom: 20,
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: 700,
  },
  rootStyle: {
    background: '#000a8c6b',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.light,
    borderBottom: '2px solid #23296F',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
  },
  titleContainer: {
    marginTop: 25,
  },
  btnPrimary: {
    padding: '16px 32px',
    backgroundColor: '#000A8C',
    color: '#fff',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
    borderRadius: '8px',
    minWidth: '300px',
    '&:hover': {
      backgroundColor: '#000A8C',
      opacity: 0.9,
    },
    '&:disabled': {
      backgroundColor: '#C5C7E0',
      color: '#fff',
    },
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#CDCEDA',
      },
      '&:hover fieldset': {
        borderColor: '#CDCEDA',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#CDCEDA',
      },
    },
  },
}));

export default useStyles; 